import router from '@/router'
import nProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { auth } from './permission'
import { queryDecrypt } from '../../utils/router'

// TODO 路由前置守卫
router.beforeEach(async function (to, from, next) {
  nProgress.start()
  // 授权验证

  const authResult = await auth(to)
  if (authResult.state) {
    next()
  } else {
    nProgress.done()

    if (authResult.toPath) {
      next(authResult.toPath)
    } else {
      next(false)
    }
  }
})

// TODO 路由后置守卫
router.afterEach(function (to) {
  to.query.v && (to.query = queryDecrypt(to.query))
  nProgress.done()
})
